import React from 'react';
import useData from './hooks';
import { FilteredListsResolverProps } from './types';
import FilteredListResolver from './FilteredListResolver';
import { useFlattenFields } from '20.formLib/DeclarationContainer/contexts';

/**
 * Ce composant permet des géré les champs avec des listes
 * @param param0
 * @returns
 */
const FilteredListsResolver = ({ children, updateDeclaration, forceFieldUpdate }: FilteredListsResolverProps) => {
  const { flattenFieldsScoped } = useFlattenFields();
  const { allListFieldsWithFilter } = useData(flattenFieldsScoped);

  return (
    <>
      {allListFieldsWithFilter.map((fieldListWithFilter) => (
        <FilteredListResolver
          key={fieldListWithFilter.fullPathId}
          fieldListWithFilter={fieldListWithFilter}
          updateDeclaration={updateDeclaration}
          otherFields={flattenFieldsScoped.filter((f) => f.fullPathId !== fieldListWithFilter.fullPathId)}
          forceFieldUpdate={forceFieldUpdate}
        />
      ))}
      {children}
    </>
  );
};

export default FilteredListsResolver;
